export default __webpack_public_path__ + "static/media/nassal.0fdb5648.png";